import { render, staticRenderFns } from "./AlteracaoSegmentation.vue?vue&type=template&id=463374f0&scoped=true"
import script from "./AlteracaoSegmentation.vue?vue&type=script&lang=js"
export * from "./AlteracaoSegmentation.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoSegmentation.vue?vue&type=style&index=0&id=463374f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463374f0",
  null
  
)

export default component.exports